import React from 'react';

export default function SceneManager({
  scenes,
  currentSceneIndex,
  setCurrentSceneIndex,
  setCurrentScene,
  setCurrentSceneContent,
  setSceneDescription,
  setArtworkDetails,
  setShowSceneCreator,
  setCurrentSceneNumber,
  handleNextScene,
  handleSaveStory,
  storyTitle,
  setStoryTitle,
  currentSceneContent,
  setCurrentSceneContent: setContent,
  onTellAtmosphereAboutArtwork
}) {
  // Tab navigation for scenes
  const renderSceneTabs = () => {
    if (!scenes || scenes.length === 0) return null;
    return (
      <div className="flex gap-2 mb-4">
        {scenes.map((scene, idx) => (
          <button
            key={idx}
            onClick={() => {
              setCurrentSceneIndex(idx);
              setCurrentScene(scenes[idx]);
              setCurrentSceneContent(scenes[idx].description);
              setSceneDescription(scenes[idx].description || '');
              setArtworkDetails(scenes[idx].artworkDetails || '');
            }}
            className={`px-4 py-2 rounded-xl font-semibold text-sm transition-all duration-300 border-2 focus:outline-none ${
              idx === currentSceneIndex
                ? 'bg-amber-500 text-white border-amber-700 shadow-lg'
                : 'bg-white text-amber-700 border-amber-200 hover:bg-amber-100'
            }`}
          >
            Scene {idx + 1}
          </button>
        ))}
      </div>
    );
  };

  // New story flow (first time user)
  const renderNewStoryFlow = () => (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="text-white text-lg sm:text-2xl font-extrabold text-center mb-6 mt-12 drop-shadow-lg leading-snug">
        Hello fellow storyteller,<br />
        let's begin the story adventure with Artmosphere!
      </div>
      <button
        onClick={onTellAtmosphereAboutArtwork}
        className="px-6 py-3 bg-gradient-to-r from-amber-500 to-amber-400 text-white rounded-xl font-semibold shadow hover:from-amber-600 hover:to-amber-500 transition-all duration-300"
      >
        Tell Artmosphere about this artwork
      </button>
      <p className="text-white text-center max-w-md drop-shadow-lg text-sm sm:text-base px-4 mt-4">
        Click to answer questions about your artwork and start your magical story adventure!
      </p>
    </div>
  );

  // Main story content UI
  const renderStoryContent = () => (
    <>
      {/* Scene Navigation */}
      {renderSceneTabs()}
      {/* Story Title */}
      <div className="bg-white/90 backdrop-blur-sm border-2 border-amber-200 rounded-2xl shadow-lg p-2 sm:p-3 mb-4">
        <label className="block text-sm font-semibold text-amber-800 mb-1">
          📚 Story Title
        </label>
        <input
          type="text"
          value={storyTitle}
          onChange={e => setStoryTitle(e.target.value)}
          placeholder="Enter your story title"
          className="text-base sm:text-lg font-bold w-full px-2 py-1 border-b-2 border-amber-200 bg-transparent focus:outline-none focus:border-amber-500"
        />
      </div>
      {/* Scene Content */}
      <div className="bg-white/90 backdrop-blur-sm border-2 border-amber-200 rounded-2xl shadow-lg p-3 sm:p-6">
        <label className="block text-sm font-semibold text-amber-800 mb-2">
          ✍️ Scene {currentSceneIndex + 1} Content
        </label>
        <textarea
          value={currentSceneContent}
          onChange={e => setContent(e.target.value)}
          placeholder="Write your story scene here..."
          className="w-full min-h-[150px] sm:min-h-[200px] p-2 sm:p-3 rounded-lg border-2 border-amber-100 focus:border-amber-400 focus:outline-none bg-amber-50/50 text-amber-900 text-sm sm:text-base"
        />
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={async () => { await handleSaveStory(); }}
            className="flex items-center gap-2 bg-gradient-to-r from-amber-400 to-amber-300 text-white font-semibold py-2 px-4 rounded-xl shadow hover:from-amber-500 hover:to-amber-400 transition-all duration-300 text-base"
          >
            Save Scene
          </button>
          <button
            onClick={handleNextScene}
            className="flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-400 text-white font-semibold py-2 px-4 rounded-xl shadow hover:from-amber-600 hover:to-amber-500 transition-all duration-300 text-base"
          >
            <span className="text-lg">➕</span> Next Scene
          </button>
        </div>
      </div>
    </>
  );

  return {
    renderNewStoryFlow,
    renderStoryContent
  };
} 